import { QueryKey } from "@tanstack/react-query";
import { GetAlertParams } from "./alert.type";

export const ALERT_KEYS = {
  ALERT: "alert",
  GET_ALERTS: (params?: GetAlertParams): QueryKey => [
    ALERT_KEYS.ALERT,
    "list",
    params,
  ],
};
